
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.858 2h4.136l.234.36c.42.648 1.879 2.066 4.067 2.066h.567L20 7.934l-.42.353c-.615.517-1.352 1.491-1.563 2.683-.201 1.134.05 2.592 1.621 4.206l.344.354-1.16 3.577-.681-.14c-1.157-.238-3.879-.12-5.512 2.119L11.96 22l-.617-.951c-.473-.73-1.43-1.266-2.594-1.613a11.408 11.408 0 00-3.047-.453h-.567L4 15.48l.413-.353c.697-.597 1.508-1.659 1.738-2.87.215-1.13-.047-2.526-1.738-3.975L4 7.93l1.136-3.503h.567c.583 0 1.509-.11 2.34-.433.845-.328 1.43-.808 1.636-1.44L9.858 2z","fill":"currentColor"}})])
          )
        }
      }
    